import React from "react";
import { connect } from "react-redux";
import FileDropZone from "../sub/FileDropZone";
import { FormattedMessage, injectIntl } from "react-intl";
import { Modal, Badge, Container, Row, Col, Image } from "react-bootstrap";
import Icon from "../sub/Icon";
import MenuButton from "../sub/bootstrap/MenuButton";

class UploadImgModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      // Uploaded files
      customImg: [],
      disabledDropzone: false,
      previewImage: false,
      show: true,
    };
  }

  close() {
    this.setState({ show: false }, () => {
      // Add a timeout to allow smooth closing of the modal before executing the callback
      setTimeout(() => this.props.closeModal(), 100);
    });
  }

  onComplete() {
    this.setState({
      disabled: true,
      progressBarVisibility: true,
      progressbarMessage: <FormattedMessage id="Image.Upload.In.Progress" />,
    });

    this.props.onComplete(this.state.customImg);
  }

  onDropFile(files) {
    const that = this;

    var reader = new FileReader();
    reader.onloadend = function () {
      var imageSrc = reader.result;
      that.setState({
        customImg: [files],
        disabledDropzone: true,
        previewImage: imageSrc,
        disabled: false,
      });
    };

    reader.readAsDataURL(files);
  }

  abortCustomImage() {
    this.setState({
      customImg: [],
      disabledDropzone: false,
      previewImage: false,
    });
  }

  disabled() {
    return this.state.disabled || !this.state.customImg.length;
  }

  render() {
    const { currentImage } = this.props;

    return (
      <Modal
        show={this.state.show}
        onHide={() => this.close()}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage id="Image.Update" />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container>
            <Row>
              <Col md={5} className="text-center">
                <Badge bg="success" className="mb-2">
                  <FormattedMessage id="Image.Current" />
                </Badge>

                <div className="card-img-top d-block mx-auto">
                  <Image width={200} src={currentImage} thumbnail alt="" />
                </div>
              </Col>

              <Col md={2} className="text-center">
                <Icon
                  className={
                    this.state.disabledDropzone
                      ? "fa-3x text-success pt-5 mt-5"
                      : "fa-3x text-secondary pt-5 mt-5"
                  }
                  icon={
                    this.state.disabledDropzone ? "arrow-right" : "arrow-right"
                  }
                />
              </Col>

              <Col md={5} className="text-center">
                <Badge bg="warning" className="mb-2">
                  <FormattedMessage id="Image.New" />
                </Badge>
                {!this.state.disabledDropzone && (
                  <FileDropZone
                    onDropFile={(file) => this.onDropFile(file)}
                    acceptedExtensions={["jpg", "jpeg", "png", "webp"]}
                    appearance="thumbnail"
                    multiple={false}
                  />
                )}
                {this.state.disabledDropzone && (
                  <div>
                    <div
                      className="card-img-top d-block mx-auto img-thumbnail"
                      style={
                        this.state.disabledDropzone && {
                          border: "1px solid #28a745",
                        }
                      }
                    >
                      <Image
                        width={200}
                        src={this.state.previewImage}
                        thumbnail
                        alt=""
                      />
                    </div>
                    <MenuButton
                      icon="trash"
                      className="mt-3"
                      onClick={() => this.abortCustomImage()}
                      variant="danger"
                      hover={<FormattedMessage id="Delete" />}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <MenuButton variant="secondary" onClick={() => this.close()}>
            <FormattedMessage id="Cancel" />
          </MenuButton>
          {!this.disabled() && (
            <MenuButton onClick={() => this.onComplete()}>
              <FormattedMessage id="Import" />
            </MenuButton>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(UploadImgModal));
